import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import Footer from '../components/Footer';
import SEOHead from '../components/SEOHead';
import '../styles/HomePage.css';

const HomePage = () => {
  const [scrollY, setScrollY] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavigation = (path) => {
    if (path === 'technology') {
      navigate('/technology');
    } else if (path === 'applications') {
      navigate('/applications');
    } else {
      // Scroll to section on same page
      document.getElementById(path)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="homepage">
      <SEOHead 
        title="SolidCloud International | Advanced Aerogel Materials"
        description="Leading innovation in aerogel technology for thermal protection, energy systems, and high-performance industrial applications. Redefining lightweight performance materials."
        keywords="aerogel, thermal insulation, lightweight materials, EV battery safety, industrial insulation, aerospace materials, India materials innovation"
      />
      <HeroSection scrollY={scrollY} onNavigate={handleNavigation} />
      <AboutSection />
      <Footer onNavigate={handleNavigation} />
    </div>
  );
};

export default HomePage;
